import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Platform', href: '#platform' },
    { label: 'Security', href: '#firewall' },
    { label: 'Documentation', href: '#documentation' },
    { label: 'Pricing', href: '#pricing' },
    { label: 'Company', href: '#company' },
  ];

  return (
    <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`} data-testid="navbar">
      <div className="container navbar-container">
        <a href="/" className="navbar-logo" data-testid="navbar-logo">
          <span className="logo-icon">VS</span>
          <span className="logo-text">VantaSignal</span>
        </a>

        <div className={`navbar-links ${isMobileMenuOpen ? 'active' : ''}`}>
          {navLinks.map((link) => (
            <a 
              key={link.label} 
              href={link.href} 
              className="navbar-link"
              data-testid={`nav-${link.label.toLowerCase()}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="navbar-actions">
          <a 
            href="mailto:contact@vantasignal.app" 
            className="btn btn-primary"
            data-testid="request-demo-btn"
          >
            Request Demo
          </a>
          <button 
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="mobile-menu" data-testid="mobile-menu">
          {navLinks.map((link) => (
            <a 
              key={link.label} 
              href={link.href} 
              className="mobile-menu-link"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a 
            href="mailto:contact@vantasignal.app" 
            className="btn btn-primary mobile-cta"
          >
            Request Demo
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
